import { FC } from 'react';
import CardsWrapper from '../../cardsWrapper';
import RestaurantCardView from '../restaurantCardView/restaurantCard.view';
import { useRoomNavigation } from '../../hooks/useRoomNavigation';
import { RestaurantCardProps } from '../restaurantCard.types';

export const RestaurantCardController: FC<RestaurantCardProps> = ({
  room,
  index,
}) => {
  const { openCopiaHandler } = useRoomNavigation(room, () => {});

    return (
       <CardsWrapper image={room.logo} action={openCopiaHandler} room={room}>
           <RestaurantCardView room={room} index={index}/>
       </CardsWrapper>
   )
}
